// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BrowseController from "./browse_controller.js"
application.register("browse", BrowseController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import IngredientsController from "./ingredients_controller.js"
application.register("ingredients", IngredientsController)

import StepsController from "./steps_controller.js"
application.register("steps", StepsController)
